import { icon } from '../components/icons';
import { ctaBand } from '../components/sections';
import { categoryLabel } from '../content/insight-categories';
import { SITE_POSTS } from '../content/site-posts';
import { SITE_CONFIG } from '../config/site-config';
import type { SitePost } from '../features/insights/insight-types';
import { escapeHtml, safeUrl } from '../lib/html';
import { EXTERNAL_LINK_ATTRS, routeHref } from '../lib/links';

/** Article template for /insights/<slug>. Renders only for posts in content/site-posts.ts. */
export function pageArticle(post: SitePost): string {
  const related = SITE_POSTS.filter((x) => x.category === post.category && x.slug !== post.slug).slice(0, 3);
  const slug = encodeURIComponent(post.slug);
  const category = categoryLabel(post.category);
  const coverSrc = post.cover ? safeUrl(post.cover.src) : '';
  return `
  <article class="s" style="padding-top:72px">
    <div class="wrap narrow">
      <nav class="crumbs" aria-label="Breadcrumb"><a href="${routeHref('/insights')}">Insights</a> / <a href="${routeHref(`/insights?category=${encodeURIComponent(post.category)}`)}">${category}</a></nav>
      <span class="tag">${category}</span>
      <h1 id="h1" style="margin:18px 0 12px">${escapeHtml(post.title)}</h1>
      <p class="fine">${escapeHtml(post.date)} · ${escapeHtml(post.readTime)} · ${escapeHtml(post.author ?? 'ReTax360')}</p>
      ${post.cover && coverSrc ? `<img src="${escapeHtml(coverSrc)}" alt="${escapeHtml(post.cover.alt)}" loading="lazy" style="border-radius:22px;margin:28px 0">` : ''}
      <div class="prose">${post.body}</div>
      <p class="share"><a class="tlink" href="https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`${SITE_CONFIG.SITE_URL}/insights/${slug}`)}" ${EXTERNAL_LINK_ATTRS}>Share on LinkedIn ${icon('arrow')}</a> <button class="tlink" data-copy="${SITE_CONFIG.SITE_URL}/insights/${slug}">Copy link</button></p>
      ${related.length ? `<h2 class="h-cap">Related insights</h2>${related.map((r) => `<p><a class="tlink" href="${routeHref(`/insights/${encodeURIComponent(r.slug)}`)}">${escapeHtml(r.title)} ${icon('arrow')}</a></p>`).join('')}` : ''}
    </div>
  </article>
  ${ctaBand()}`;
}
